import { render, staticRenderFns } from "./table.abb.vue?vue&type=template&id=4bc9ab75"
import script from "./table.abb.vue?vue&type=script&lang=js"
export * from "./table.abb.vue?vue&type=script&lang=js"
import style0 from "./table.abb.vue?vue&type=style&index=0&id=4bc9ab75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports